

















































import { computed, defineComponent, inject, ref } from '@vue/composition-api';
import ConfForm from '@/components/form';
import { SpecificPropsType } from '@/components/form/types';
import { ConfTableKey } from '@/components/table/table';
import AuthConfirm from '@/components/auth-confirm-v2/index.vue';
import {
    handleErrorMessageToast,
    handleSuccessMessageToast,
} from '@/common/util';
import {
    applyMPA,
    checkAppId,
    createMPAAuthToken,
    MPAApplication,
    MpApp,
} from '@/apis/plc';
import { applyFormOptions, MPAApplicationForm } from './apply-plc-form';

export default defineComponent({
    components: {
        AuthConfirm,
        ConfForm,
    },
    props: ['row', 'fetch', 'scopeGroupId'] as unknown as SpecificPropsType<{
        scopeGroupId: number;
        row?: MpApp;
        fetch?: () => void;
    }>,
    setup(props, { root }) {
        const edit = !!props.row;
        const scopeGroupId = props.scopeGroupId;
        const appId = root.$route.params.appId as string;
        const visible = ref(false);

        const confTable = props.fetch
            ? { fetch: props.fetch }
            : inject(ConfTableKey);
        const initialValue = ref<() => MPAApplicationForm>(() => ({
            mpAppId: '',
            applyReason: '',
            applyUid: [],
        }));
        const authRef = ref<InstanceType<typeof AuthConfirm>>();
        const steps = ref(0);
        const remainBinding = ref(0);
        const opt = computed(() =>
            applyFormOptions[steps.value]({
                edit,
                appId,
                remainBinding: remainBinding.value,
                updateRemainBinding: (num: number) => {
                    remainBinding.value = num;
                },
            }),
        );

        const formRef = ref<InstanceType<typeof ConfForm>>();

        const auth = async (query: MPAApplication) => {
            const {
                data: { result, error_msg, data },
            } = await createMPAAuthToken({
                ...query,
                appId,
                scopeGroupId,
            });
            if (result === 1) {
                const { preApplyId } = data;
                await authRef.value!.startAuth({
                    preApplyId,
                    appId,
                });
                return preApplyId;
            }
            handleErrorMessageToast(error_msg || '认证失败');
            throw Error();
        };

        const onSubmit = async (mpaApplicationForm: MPAApplicationForm) => {
            if (!formRef.value || !authRef.value || !confTable) {
                return;
            }
            const mpaApplication = {
                ...mpaApplicationForm,
                applyUid: mpaApplicationForm.applyUid.map((it) => it.id),
            };
            const preApplyId = await auth(mpaApplication);
            const res = await applyMPA({
                appId,
                ...mpaApplication,
                preApplyId,
                scopeGroupId,
            });
            if (res.data.result === 1) {
                handleSuccessMessageToast(edit ? '重新申请成功' : '申请成功');
                confTable.fetch();
                visible.value = false;
            } else {
                handleErrorMessageToast(
                    res.data.error_msg || (edit ? '重新申请失败' : '申请失败'),
                );
            }
        };

        const canSubmit = computed(() => formRef.value?.canSubmit);

        const handleOperate = () => {
            const row = props.row;
            if (row) {
                initialValue.value = () => ({
                    mpAppId: row.mpAppId,
                    applyReason: row.applyReason,
                    applyUid: row.applyUid.map((id) => ({ id: String(id) })),
                });
                checkAppId(appId, row.mpAppId).then(
                    (res) => {
                        remainBinding.value = res.data.data.remainBinding;
                    },
                    () => {},
                );
                setTimeout(() => {
                    if (formRef.value) formRef.value.reset();
                });
            }
            visible.value = true;
        };

        const handleNext = async () => {
            if (formRef.value) {
                const err = await formRef.value.form.validate();
                if (err.length) return;
                if (applyFormOptions.length - 1 === steps.value) {
                    formRef.value.submit();
                } else {
                    steps.value += 1;
                }
            }
        };

        const handleCancel = () => {
            visible.value = false;
            setTimeout(() => {
                steps.value = 0;
            }, 200);
        };

        return {
            initialValue,
            options: opt,
            authRef,
            formRef,
            onSubmit,
            visible,
            canSubmit,
            handleOperate,
            applyFormOptions,
            steps,
            handleNext,
            handleCancel,
        };
    },
});
